import { IOnboardingTarget } from "../GameObjects/IOnboardingTarget";

export class OnboardingStep {
    // Takes a Topic, a Data and a Position, delay, and forceSequence
    public readonly event: string;
    public readonly data: any;
    public readonly target: IOnboardingTarget | IOnboardingTarget[];
    public readonly hintDelay: number;
    public readonly isOrdered: boolean;
    public readonly failure: string | undefined;
    public readonly onComplete: (() => void) | undefined;
    public isComplete: boolean;

    constructor(
        pEvent: string,
        pData: any,
        pTarget: IOnboardingTarget | IOnboardingTarget[],
        pHintDelay: number,
        pIsOrdered: boolean,
        pFailure?: string,
        pOnComplete?: () => void,
    ) {
        this.event = pEvent;
        this.data = pData;
        this.target = pTarget;
        this.hintDelay = pHintDelay;
        this.isOrdered = pIsOrdered;
        this.onComplete = pOnComplete;
        this.failure = pFailure;
        this.isComplete = false;
    }
}
